import { i18n } from '../i18n';

/** Maps our locale codes to BCP 47 language tags for Intl/toLocaleDateString. */
const LOCALE_BCP47_MAP: Record<string, string> = {
  en: 'en-GB',
  de: 'de-DE',
  bg: 'bg-BG',
};

/**
 * Format "YYYY-MM-DD" → locale-appropriate date string.
 *
 * Examples:
 *   en → "13 Mar 2026"   (en-GB)
 *   de → "13. März 2026" (de-DE)
 *   bg → "13 март 2026 г." (bg-BG)
 */
export const formatDate = (iso: string): string => {
  const [year, month, day] = iso.split('-').map(Number);
  const activeLocale = i18n.language ?? 'en';
  const bcp47 = LOCALE_BCP47_MAP[activeLocale] ?? 'en-GB';
  return new Date(year, month - 1, day).toLocaleDateString(bcp47, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};
